import { Message, sendMessage } from './Communication';
import { AsyncFunction } from '../utils/Types';

type InitializationActions = 'started' | 'finished' | 'update';

interface InitializationArguments {
    message: string;
}

function sendInitializationMessage(action: InitializationActions, message?: string): Promise<void> {
    let args: InitializationArguments | undefined;

    if (message != null) {
        args = {
            message
        };
    }

    return sendMessage<Message<InitializationArguments | undefined>>(
        {
            type: 'initialization',
            action,
            arguments: args
        },
        true
    );
}

export const startInitialization: (message?: string) => Promise<void> = (message?: string) => sendInitializationMessage('started', message);
export const updateInitializationMessage: (message?: string) => Promise<void> = (message?: string) => sendInitializationMessage('update', message);
export const finishInitialization: AsyncFunction = () => sendInitializationMessage('finished');


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/submodules/app-api/Initialization.ts